import styled from 'styled-components';
import MediaSizes from '@widgets/shared/MediaSizes';
export const Img = styled.img `
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  z-index: 1;

  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
  }
`;
export const Title = styled.span `
  position: relative;
  z-index: 3;
  color: white;
  text-align: left;
  font: var(--heading-three-font);
  margin-bottom: 0;
  max-width: 15rem; // ski and snowboard 2 lines
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    font: var(--heading-four-font);
    margin-bottom: 0;
    max-width: 11rem;
  }
`;
export const Element = styled.a `
  border-radius: var(--border-radius-sm);
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  padding: 1rem;
  width: 100%;
  height: 16.5rem;
  position: relative;
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  border: none;
  text-decoration: none;
  cursor: pointer;
  
  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    height: 9.8rem;
    width: 100%;
    background-image: linear-gradient(180deg, rgba(0, 91, 185, 0) 0%, #00356D 100%);
    box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.1);
    opacity: 0.6;
    z-index: 2;
  }
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    height: auto;
    aspect-ratio: 162 / 100;
    
    &:after {
      height: 6rem;
    }
  }.
  
  @media screen and (min-width: 480px){
    height: 13rem;
  }
  
  @media screen and (min-width: 768px){
    height: 16rem;
    max-height: 16rem;
  }
`;
export default {
    Img,
    Title,
    Element,
};
